<template>
<!--  <Header></Header>-->
  <div class="logo-container">
    <img class="img-fluid img-sgnin" src="../assets/logo.svg" alt="Logo" />
  </div>

  <div class="login">
    <h2>Sign in</h2>
    <div v-if="error.length" class="alert-danger mt-3 ps-3 pe-3">
      {{ error }}
    </div>
    <section class="signin" @keyup.enter="doSignIn">
      <div class="mt-3">
        <input type="email" v-model="email" placeholder="Email" class="form-control" />
      </div>
      <div class="mt-3">
        <input type="password" v-model="password" placeholder="Password" class="form-control" />
      </div>
      <div class="mt-3">
        <a role="button" class="procricket-btn float-end ps-5 pe-5" @click="doSignIn">Sign In</a>
      </div>
    </section>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AuthService from '@/services/auth-service'
import AdminService from "@/services/admin-service";

export default defineComponent({

  data () {
    return {
      email: '',
      password: '',
      error: '',
      submitted: false,
      valid: false
    }
  },
  created() {
    if (localStorage.getItem('access_token')) {
      this.$router.push('/')
    }
  },
  methods: {
    doSignIn () {
      AuthService.signIn(this.email, this.password).then(() => {
        AdminService.getApplications().then(() => {
          this.$router.push('/')
        }).catch(() => {
          this.error = 'Login failed';
          this.loading = false;
        })
      }).catch(() => {
        this.error = 'Login failed'
      })
    }
  }
})
</script>
<style src="../assets/style.css">
</style>
